import request from "@/utils/request";

// 自动登录
export function autoLoginApi(data) {
  return request({
    url: `/fmsapi/common/AutoLogin`,
    method: "post",
    data,
  });
}
// 登录
export function loginFun(data) {
  return request({
    url: `/fmsapi/common/Login`,
    method: "post",
    data,
  });
}
//获取激活用户信息
export function getActivateUser(data) {
  return request({
    url: `/fmsapi/common/GetActivateUser`,
    method: "post",
    data,
  });
}
//提交激活用户信息
export function activateUser(data) {
  return request({
    url: `/fmsapi/common/ActivateUser`,
    method: "post",
    data,
  });
}
//登录已激活用户信息
export function loginActivateUser(data) {
  return request({
    url: `/fmsapi/common/LoginActivateUser`,
    method: "post",
    data,
  });
}
//通过code获取微信信息
export function getWeChatByCode(data) {
  return request({
    url: `/fmsapi/common/GetWeChatByCode`,
    method: "post",
    data,
  });
}
//微信登录授权绑定
export function weChatLoginApi(data) {
  return request({
    url: `/fmsapi/common/WeChatLogin`,
    method: "post",
    data,
  });
}
//微信绑定邮箱或手机登录账号
export function bindPhoneOrEmailApi(data) {
  return request({
    url: `/fmsapi/common/BindPhoneOrEmail`,
    method: "post",
    data,
  });
}
